import { Competition } from "../../models";

export function getCompetitionStatus(competition: Competition) {
    if (competition.status === "published") return "Approved";
    else if (competition.status === "draft") return "Pending Approval";
    else if (competition.status === "cancelled") return "CANCELLED";
    else return "Error: Status not found.";
}

export function getCompetitionStatusColor(competition: Competition) {
    if (competition.status === "published") return "success";
    else if (competition.status === "draft") return "warning";
    else if (competition.status === "cancelled") return "danger";
    else return "danger";
}